'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    PropTypes = React.PropTypes,
    mui = require('material-ui'),
    set = require('lodash/object').set,
    get = require('lodash/object').get,
    {trim} = require('lodash/string'),
    AppConstants = require('constants/AppConstants'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    BasicFormGroup = require('../BasicFormGroup'),
    SessionStore = require('../../../../stores/SessionStore'),
    {TextField} = mui;

const FormGroupTextfield = React.createClass({displayName: "FormGroupTextfield",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        placeHolder: PropTypes.string,
        label: PropTypes.string,
        onChange: PropTypes.func,
        messageError: PropTypes.string,
        writerAttribute: PropTypes.string,
        readerAttribute: PropTypes.string,
        name: PropTypes.string,
        decimalDigits: PropTypes.bool,
        isRelaxedText: PropTypes.bool,
        noInternalValidation: PropTypes.bool,
        formatDecimal: PropTypes.string,
        isDecimalFormat: PropTypes.bool,
        amountDecimals: PropTypes.number,
        isRequired: PropTypes.bool,
        onEnter: PropTypes.func,
        className: PropTypes.string,
        onBlur: PropTypes.func,
        id: PropTypes.string
    }),

    _el: null,

    componentDidMount() {
        const {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
    },

    clean() {
        if (this.refs && this._el) {
            this._el.clearValue();
        }
    },

    getValue() {
        const {writerAttribute, readerAttribute, isDecimalFormat} = this.props;

        let value;
        if (this._el) {
            value = trim(this._el.getValue());
        } else {
            value = '';
        }
        const writerAttributeSafe = writerAttribute || readerAttribute; // make writer attribute optionally
        const valueUpdated = isDecimalFormat ? NumberUtils.standardiseDecimalFormatNumber(value) : value;
        const wrapper = set({}, writerAttributeSafe, valueUpdated);

        return wrapper;
    },

    isValid(onFinishValidation) {
        let {name, additionalValidation, isRequired, isRelaxedText, isDecimalFormat, noInternalValidation} = this.props;
        if (ContentUtils.isNull(isRequired)) {
            isRequired = true;
        }

        const inputValue = trim(this._el.getValue());

        let messageError = '';

        if(!noInternalValidation){
            //console.log(this.props);
            if (isRelaxedText && inputValue) {
                messageError = ContentUtils.isValidTextNotRequiredWithCustomValidation(inputValue, name, AppConstants.REGEX_NAME_RELAXED);
            } else {
                if (isRequired) {
                    messageError = ContentUtils.isValidText(inputValue, name);
                } else {
                    messageError = ContentUtils.isValidTextNotRequired(inputValue, name);
                }
            }
        }

        if (!messageError && additionalValidation) {
            messageError = additionalValidation(inputValue);
        }

        this.setState({messageError: messageError}, () => {
            if (onFinishValidation) {
                onFinishValidation();
            }
        });


        if (isDecimalFormat && this._isNumberMoreThanPrecisionTen(NumberUtils.standardiseDecimalFormatNumber(inputValue))) {
            messageError = t('form_group_textfield_error_message_amount_so_longer');
        }

        return messageError === '';
    },

    _isNumberMoreThanPrecisionTen(number) {
        return get(number, 'length') > 10 || 0;
    },

    _onEnter() {
        if (this.props.onEnter) {
            this.props.onEnter();
        }
    },

    _onBlur() {
      this.isValid(this.props.onBlur);
    },

    render() {
        const {isDisabled, label, onChange, value, readerAttribute, isDark, isImmutable, isEditMode, isDecimalFormat, decimalDigits, className} = this.props;

        // is disabled input
        const isDisabledInput = !!isDisabled || isImmutable && isEditMode;

        // prepare specific classes
        let textFieldClassName = 'form-group form-group-textfield';
        textFieldClassName += isDark ? ' is-dark' : '';
        textFieldClassName += (isDisabledInput ? ' is-disabled' : '');
        textFieldClassName += ' is-dark';
        if (className) {
            textFieldClassName += ' ' + className;
        }
        const classNameElement = 'form-group-textfield-input' + (isDisabledInput ? ' is-disabled' : '');

        let textFieldValue = "";

        const decimalPositionsSettings = get(SessionStore.getCurrentCurrencyDigits(), 'value');

        if(readerAttribute){
            // the input value
            textFieldValue = value === undefined ? '' : get(value, readerAttribute, '');
            textFieldValue = isDecimalFormat ? NumberUtils.formatDecimal(textFieldValue, decimalPositionsSettings) : textFieldValue;
        } else{
            textFieldValue = value;
            textFieldValue = isDecimalFormat ? NumberUtils.formatDecimal(textFieldValue, decimalPositionsSettings) : textFieldValue;
        }

        return (
            React.createElement("div", {className: textFieldClassName, id: this.props.id}, 
                React.createElement(TextField, {
                    ref:  ref => this._el = ref, 
                    className: classNameElement, 
                    floatingLabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    LabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    onChange: onChange, 
                    onBlur:  this._onBlur, 
                    onEnterKeyDown: this._onEnter, 
                    defaultValue: textFieldValue, 
                    floatingLabelText:  label ? label : '', 
                    style: {width: '100%', color: 'white !important', fontWeight: '300'}, 
                    disabled: isDisabledInput, 
                    errorText:  get(this.state, 'messageError', '') 
                }
                )
            )
        );
    }
});

module.exports = FormGroupTextfield;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield.jsx
 **/